import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const ClientDashboard = lazy(() => import("./ClientDashboard"));

const CLIDASH_ROUTES: RouteObject[] = [
  {
    path: "/private/users-summary",
    element: React.createElement(ClientDashboard),
  },
];

export default CLIDASH_ROUTES;
